export type Cast<V, T> = V extends T ? V : T;
